import $ from 'jquery';

// IMPORT COMPONENTS
import A11yUtils from '@core/base/scripts/utils/a11y-utils';
import Utils from '@core/base/scripts/utils/utils';
import Subnav from '@pj/components/navigation/subnav/subnav';
import BurgerButton from '@core/components/buttons/burger-button/burger-button';
import SwitchLang from '@core/components/dropdowns/switch-lang/switch-lang';



export default class NavigationBar {
  constructor() {
    this.CLASSES = {
      scrollDisabled: 'scroll-disabled',
      nav: {
        top: 'navigation-bar__top',
        bottom: 'navigation-bar__bottom__list',
        quickAccess: 'navigation-bar__quick-access'
      },
      mobileNav: {
        opening: 'mobile-nav--opening',
        closing: 'mobile-nav--closing',
        opened: 'mobile-nav--opened'
      }
    };
    this.TIMEOUT = 300;
    //
    this.$module = null;
    this.$header = null;
    this.$menuFocusables = null;
    this.$currentLink = null;
    this.$bottomNav = null;
    this.$body = null;
    this.initialSize = null;
    this.subnavComponent = null;
    this.burgerButton = null;
    this.switchLang = null;
    //
    this.isInit = false;
  }

  init(module) {
    this.$module = module;
    this.initialSize = $(window).width();
    this.$body = $('body');
    this.$header = $('.header');
    this.$wrapper = $('.navigation-bar');
    this.$bottomNav = $(`.${this.CLASSES.nav.bottom}`, this.$wrapper);
    this.$btns = $(`[${A11yUtils.ARIA.controls}]`, this.$bottomNav);
    this.$currentLink = $(this.$btns[0]);
    this.isInit = true;
    //
    this.initBurger();
    this.initSubNav();
    this.initSwitchLang();
    this.onClick();
    this.onResize();
    this.iosFix()
    //
  }

  initSwitchLang() {
    this.switchLang = new SwitchLang(this.$module);
    this.switchLang.init(this);
  }

  initBurger() {
    this.burgerButton = new BurgerButton(this.$wrapper);
    this.burgerButton.init();
    this.burgerButton.onClick((that) => {
      this.toggleMobileNav(that.toggled);
    });
  }

  initSubNav() {
    this.subnavComponent = new Subnav(this);
    this.subnavComponent.init();
  }

  onClick() {
    this.$btns.off().on('click', (e) => {
      e.preventDefault();
      this.$currentLink = $(e.currentTarget);
      if (this.$currentLink.attr(A11yUtils.ARIA.expanded) !== 'true') {
        this.openSubnav();
      } else {
        this.closeSubnav();
      }
    });

    $(document).on('click', (e) => {
      if (this.subnavComponent.isOpen() && $(e.target).closest(`.${this.CLASSES.nav.bottom}`).length === 0) {
        this.closeSubnav();
      }
    });
  }


  openSubnav() {
    this.subnavComponent.open(this.$currentLink, 0, this.$header.outerHeight(true), () => {
      if (!Utils.isTablet) {
        this.setFocusables(this.$bottomNav);
      } else {
        $(`.${this.CLASSES.nav.quickAccess}`).addClass('navigation-bar__quick-access--hide');
        this.$bottomNav.find('.navigation-bar__link').hide();
        this.setFocusables(this.$wrapper);
      }
    });
  }

  closeSubnav() {
    $(`.${this.CLASSES.nav.quickAccess}`).removeClass('navigation-bar__quick-access--hide');
    this.$bottomNav.find('.navigation-bar__link').show();
    this.subnavComponent.close();
    this.setFocusables(this.$wrapper);
  }


  onKeyDown() {
    this.$menuFocusables.off('keydown');
    this.$menuFocusables.on('keydown', evt => {
      const key = evt.which;
      const target = evt.target;

      if (key === A11yUtils.keyboard.esc) {
        this.escape(evt, target);
      }

      if (key === A11yUtils.keyboard.tab) {
        this.tab(evt, target);
      }
    });
  }

  escape(evt, target) {
    if (this.subnavComponent.isOpen()) {
      evt.preventDefault();
      this.closeSubnav();
    } else if (this.burgerButton.toggled && !this.switchLang.isOpen) {
      evt.preventDefault();
      this.burgerButton.focus();
      this.toggleMobileNav(false);
    }
  }

  tab(evt, target) {
    if (evt.shiftKey) {
      if (this.$menuFocusables && target === this.$menuFocusables[0]) {
        if (this.trapFocus) {
          evt.preventDefault();
          this.$menuFocusables[this.$menuFocusables.length - 1].focus();
        } else if (this.subnavComponent.isOpen()) {
          this.closeSubnav();
        }
      }
    } else if (this.$menuFocusables && target === this.$menuFocusables[this.$menuFocusables.length - 1]) {

      if (this.trapFocus) {
        evt.preventDefault();
        this.$menuFocusables.first().focus();
      } else if (this.subnavComponent.isOpen()) {
        this.closeSubnav();
      }
    }
  }

  toggleMobileNav(bool, callback) {
    if (bool) {
      this.$module.addClass(this.CLASSES.mobileNav.opening);
    } else {
      this.$module.addClass(this.CLASSES.mobileNav.closing);
    }

    setTimeout(() => {
      this.$module.toggleClass(this.CLASSES.mobileNav.opened, bool);
      this.$body.toggleClass(this.CLASSES.scrollDisabled, bool);
      if (bool) {
        this.setFocusables(this.$wrapper);
        this.$menuFocusables[3].focus();
        this.$module.removeClass(this.CLASSES.mobileNav.opening);
      } else {
        this.destroy();
        this.burgerButton.focus();
        this.$module.removeClass(this.CLASSES.mobileNav.closing);
      }
      if (callback) {
        callback();
      }
    }, bool ? 0 : this.TIMEOUT);
  }


  setFocusables(container) {
    this.$menuFocusables = container.find(A11yUtils.FOCUSABLES_VISIBLE);
    this.onKeyDown();
  }

  isOpen() {
    return this.subnavComponent.isOpen();
  }

  onResize() {
    this.trapFocus = Utils.isTablet;

    if (this.isInit && ((!Utils.isTablet && this.initialSize < Utils.breakpoints.lg) || (Utils.isTablet && this.initialSize > Utils.breakpoints.lg))) {
      this.destroy();
    }
  }
  /**
   * Fix for IOS Safari with address bar
   * position fixed bottom 0, doesn't work well when address bar is displayed
   */
  iosFix(){
    this.switchLangHeight = 64;
    this.$switchLang = this.$module.find('.switch-lang');
    this.$scrollArea =  this.$module.find('.navigation-bar__bottom');
    this.iosFixPosition();
    window.onresize = () => {
      // window.onresize in trigger when address bar disappear
      this.iosFixPosition();
    };
  }
  iosFixPosition(){
    if(Utils.isTablet){
      this.$switchLang.css('top', window.innerHeight - this.switchLangHeight + 'px');
      const scrollareaHeight = window.innerHeight - $('.header').height();
      this.$scrollArea.css('height', scrollareaHeight )
    }else{
      this.$switchLang.css('top', '');
      this.$scrollArea.css('height', '' )
    }
  }

  destroy() {
    if (this.subnavComponent.isOpen()) {
      this.closeSubnav();
    }
    this.burgerButton.reset();
    this.subnavComponent.reset();
    this.$menuFocusables = null;
    this.$menu = null;
    this.mobileMenuOpen = false;
    this.$module.removeClass(this.CLASSES.mobileNav.closing);
    this.$module.removeClass(this.CLASSES.mobileNav.opening);
    this.$module.removeClass(this.CLASSES.mobileNav.opened);
    this.$body.removeClass(this.CLASSES.scrollDisabled);
    this.initialSize = $(window).width();
  }
}
